'use client';
// Frontière d'erreur RACINE — ne se déclenche que si le layout racine lui-même
// échoue (error.tsx ne couvre pas son propre layout). Doit fournir ses propres
// <html>/<body> : il REMPLACE le layout racine quand il est actif. Sans lui,
// un crash du layout = écran blanc, même en développement.
import { useEffect } from 'react';

export default function GlobalError({ error, unstable_retry }: { error: Error & { digest?: string }; unstable_retry: () => void }) {
  useEffect(() => {
    console.error('[bio24] erreur racine non capturée :', error);
  }, [error]);

  return (
    <html lang="fr">
      <body style={{ margin: 0, fontFamily: 'system-ui, sans-serif', background: '#f5f8fa' }}>
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
          <div style={{ maxWidth: 460, textAlign: 'center' }}>
            <div style={{ width: 56, height: 56, borderRadius: 14, background: '#fbeaea', color: '#c0392b', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, fontWeight: 700 }}>!</div>
            <h1 style={{ fontSize: 22, fontWeight: 700, color: '#16202a', margin: '20px 0 0' }}>Une erreur est survenue</h1>
            <p style={{ fontSize: 14.5, lineHeight: 1.6, color: '#47535e', margin: '10px 0 0' }}>
              L’application n’a pas pu démarrer correctement. Réessayez ; si le problème persiste, contactez l’administrateur.
            </p>
            {error?.digest && <p style={{ fontSize: 12.5, fontFamily: 'monospace', color: '#7a8894', margin: '12px 0 0' }}>Référence : {error.digest}</p>}
            <button onClick={() => unstable_retry()} style={{ marginTop: 22, fontSize: 14, fontWeight: 600, border: 'none', background: '#1f6feb', color: '#fff', borderRadius: 10, padding: '11px 22px', cursor: 'pointer' }}>Réessayer</button>
          </div>
        </div>
      </body>
    </html>
  );
}
